<template>
    <footer class="footer">
      <p></p>
    </footer>
</template>

<script></script>

<style>

.footer {
  padding-top: 8px;
  padding-bottom: 12px;
  text-align: center;
  font-size: 18px;
  background-color: var(--color-bg);
  color: var(--color-main-info);
  font-style: italic;
}

</style>